import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2bef1fc2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  "element-loading-text": "设备导入中..."
};
const _hoisted_2 = {
  class: "app-container"
};
const _hoisted_3 = {
  class: "search-container"
};
const _hoisted_4 = {
  class: "search-left"
};
const _hoisted_5 = {
  class: "table-container-wrapper"
};
const _hoisted_6 = {
  class: "table-top-flex"
};
const _hoisted_7 = {
  class: "table-title"
};
const _hoisted_8 = {
  key: 0,
  class: "button-container"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "little-title"
}, "基础信息", -1));
const _hoisted_11 = {
  class: "split-container"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "little-title"
}, "技术参数", -1));
const _hoisted_13 = {
  class: "split-container"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "little-title"
}, "传感器配置", -1));
const _hoisted_15 = {
  class: "split-container"
};
const _hoisted_16 = {
  class: "dialog-footer"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "little-title"
}, "开关阀操作", -1));
const _hoisted_18 = {
  class: "selected-actuator-list"
};
const _hoisted_19 = {
  class: "dialog-footer"
};
const _hoisted_20 = {
  class: "selected-actuator-list"
};
const _hoisted_21 = {
  class: "dialog-footer"
};
const _hoisted_22 = {
  class: "pdf-preview-container"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "30px"
  }
}, null, -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, " 仅支持xlsx格式的文件 ", -1));
const _hoisted_26 = {
  class: "dialog-footer"
};
const _hoisted_27 = {
  class: "selected-actuator-list"
};
const _hoisted_28 = {
  class: "dialog-footer"
};
const _hoisted_29 = {
  class: "selected-actuator-list"
};
const _hoisted_30 = {
  class: "dialog-footer"
};
import { useActuatorManualOperation } from '@/composables/useActuatorManualOperation';
import { ref, unref, reactive, onMounted, watch, computed } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { downloadFlie, download } from "@/utils/index";
import EIUploadMutiplePic from '@/components/EIUploadMutiplePic';
import { addActuator, editActuator, upgradeActuator, listTestPage, deleteActuator, importExcel, actuatorInvoke, startTest, finishTest, joinTest, joinOrExitTest, dictList, actuatorEport, getEnabledTestProcess, getActTaskPageAll, getTaskPageAll, batchDeployActuator, batchScrapActuator, calibrateActuator } from "@/api/deviceManage";
import { useStore } from "vuex";
import { refreshToken } from "@/api/system1/user";
import { weChatrequest } from '@/utils/request';
import Cookies from "js-cookie";
export default {
  __name: 'list',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const manualOperation = useActuatorManualOperation();
    let operatedDevice = null;
    const form = ref(null);
    const upgradeForm = ref(null);
    const wellOptions = ref([]);
    const startTestFormRef = ref(null);
    const joinTestFormRef = ref(null);
    const batchDeployFormRef = ref(null);
    const batchScrapFormRef = ref(null);
    const router = useRouter();
    const route = useRoute();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '设备管理';
    });

    // 当前选中的测试流程
    const selectedProcess = computed(() => {
      return state.processList.find(p => p.id === state.startTestForm.processId);
    });

    // 是否包含监测测试（containsMonitorTest为true时显示四个字段）
    const containsMonitorTest = computed(() => {
      return selectedProcess.value?.containsMonitorTest === true;
    });
    const formatCode = function (code, column) {
      if (code == 1) {
        return '在线';
      } else if (code == 2) {
        return '告警';
      } else if (code == 0) {
        return '离线';
      } else {
        return '离线';
      }
    };
    const formatCode1 = function (code, column) {
      // 0-待开始，1-测试中，2-已完成，3-已取消，4-异常中断
      if (code == 0) {
        return '待开始';
      } else if (code == 1) {
        return '测试中';
      } else if (code == 2) {
        return '已完成';
      } else if (code == 3) {
        return '已取消';
      } else if (code == 4) {
        return '异常中断';
      } else {
        return '-';
      }
    };
    const formatCode2 = function (code, column) {
      // 1-合格，2-不合格，3-部分合格，4-异常，NULL-未完成/已取消
      if (code == 1) {
        return '合格';
      } else if (code == 2) {
        return '不合格';
      } else if (code == 3) {
        return '部分合格';
      } else if (code == 4) {
        return '异常';
      } else {
        return '';
      }
    };
    const formatAlarmCode = function (code, column) {
      if (code == 1) {
        return '告警';
      } else {
        return '正常';
      }
    };
    const formatTesting = function (testing, column) {
      return testing ? '测试中' : '-';
    };
    const state = reactive({
      code: '',
      loading: false,
      exportLoading: false,
      saveLoading: false,
      openDataScope: false,
      openUpgrade: false,
      upgradeLoading: false,
      openOperate: false,
      loadgingDataScope: false,
      dialogVisible: false,
      multiple: true,
      testLoading: false,
      testLoading1: false,
      testLoading2: false,
      testLoading3: false,
      calibrateLoading: false,
      calibratingId: null,
      ids: [],
      testIds: [],
      startTestDialogVisible: false,
      selectedActuatorList: [],
      processList: [],
      processListLoading: false,
      startTestForm: {
        taskName: '',
        processId: '',
        planStartTime: '',
        taskIntervalMinutes: 30,
        planEndTime: '',
        remark: ''
      },
      startTestRules: {
        taskName: [{
          required: true,
          message: '请输入测试名称',
          trigger: 'blur'
        }],
        processId: [{
          required: true,
          message: '请选择测试流程',
          trigger: 'change'
        }],
        planStartTime: [{
          validator: (rule, value, callback) => {
            if (value && new Date(value).getTime() <= Date.now()) {
              callback(new Error('计划开始时间必须大于当前时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        taskIntervalMinutes: [{
          validator: (rule, value, callback) => {
            // 仅当containsMonitorTest为true时校验
            if (!containsMonitorTest.value) {
              callback();
              return;
            }
            if (value === null || value === undefined || value === '') {
              callback(new Error('请输入测试频率'));
            } else if (value < 5) {
              callback(new Error('测试频率不能小于5分钟'));
            } else if (value > 1440) {
              callback(new Error('测试频率不能大于1440分钟'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        planEndTime: [{
          validator: (rule, value, callback) => {
            // 仅当containsMonitorTest为true时校验
            if (!containsMonitorTest.value) {
              callback();
              return;
            }
            if (value && new Date(value).getTime() <= Date.now()) {
              callback(new Error('计划结束时间必须大于当前时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      },
      joinTestDialogVisible: false,
      joinSelectedActuatorList: [],
      joinTestForm: {
        testId: ''
      },
      joinTestRules: {
        testId: [{
          required: true,
          message: '请选择测试任务',
          trigger: 'change'
        }]
      },
      testList: [],
      testListLoading: false,
      operateForm: {},
      operateFormRules: {},
      uploadForm: {
        fileList: []
      },
      uploadFormRules: {
        fileList: [{
          required: true,
          message: "上传文件不能为空",
          trigger: "blur"
        }]
      },
      // 批量出厂表单
      batchDeployForm: {
        targetTenantId: null,
        remark: '批量执行器出厂交付给客户'
      },
      batchDeployRules: {
        targetTenantId: [{
          required: true,
          message: '请选择目标租户',
          trigger: 'change'
        }]
      },
      batchDeployLoading: false,
      openBatchDeploy: false,
      deploySelectedActuatorList: [],
      // 批量报废表单
      batchScrapForm: {
        scrapReason: '',
        remark: ''
      },
      batchScrapRules: {
        scrapReason: [{
          required: true,
          message: '请输入报废原因',
          trigger: 'blur'
        }]
      },
      batchScrapLoading: false,
      openBatchScrap: false,
      // 检测报告相关
      openTestReport: false,
      testReportLoading: false,
      currentActId: 0,
      currentTaskId: '',
      testReportList: [],
      reportDialogVisible: false,
      currentPdfUrl: '',
      taskOptions: [],
      tableData: {
        rows: [],
        total: 0
      },
      selectListAll: {
        "fmsccj": [],
        //阀门生产厂家
        "fmlx": [],
        //阀门类型
        "qdmdcj": [],
        //气动马达厂家
        "krqtcgqbh": [],
        //可燃气体传感器编号
        "krqtcgqtxfs": [],
        //可燃气体传感器通信方式
        "krqtcgqlcfw": [],
        //可燃气体传感器量程范围
        "gxylcgqbh": [],
        //管线压力传感器编号
        "gxylcgqtxfs": [],
        //管线压力传感器通信方式
        "gxylcgqlcfw": [],
        //管线压力传感器量程范围
        "ylcgqbh": [],
        //压力传感器编号
        "ylcgqlcfw": [],
        //压力传感器量程范围
        "ylcgqtxfs": [],
        //压力传感器通信方式
        "weylcgqbh": [],
        //液位压力传感器编号
        "ywylcgqtxfs": [],
        //液位压力传感器通信方式
        "ywylcgqlcfw": [],
        //液位压力传感器量程范围
        "gxjylcgqbh": [],
        //管线压力进传感器编号
        "gxjylcgqtxfs": [],
        //管线压力进传感器通信方式
        "gxjylcgqlcfw": [],
        //管线压力进传感器量程范围
        "gxcylcgqbh": [],
        //管线压力出传感器编号
        "gxcylcgqtxfs": [],
        //管线压力出传感器通信方式
        "gxcylcgqlcfw": [] //管线压力出传感器量程范围
      },
      queryParams: {
        pageSize: 15,
        pageNum: 1,
        actNum: "",
        actStatus: "",
        location: "",
        order: "",
        prop: "",
        areaId: ''
      },
      actNum: null,
      point: null,
      formUpgrade: {
        fmSize: "",
        fmCrc: ""
      },
      // 表单参数
      form: {
        tenantId: null,
        actNum: "",
        actType: 2,
        pollIntervalHours: 24,
        imei: '',
        airManufacturer: "",
        airMotor: "",
        // areaId:"",
        branch: "",
        combPressureScm: "",
        combPressureSn: "",
        combPressureSr: "",
        cylinderEndTime: "",
        cylinderNum: "",
        // latitude:"",
        // location:"",
        // longitude:"",
        motherBorderModel: "",
        motherBorderVersion: "",
        pipelinePressureScm: "",
        pipelinePressureSn: "",
        pipelinePressureSr: "",
        pressureScm: "",
        pressureSn: "",
        pressureSr: "",
        liquidLevelPreSn: "",
        liquidLevelPreSr: "",
        liquidLevelPreScm: "",
        pipelineInPreSn: "",
        pipelineInPreSr: "",
        pipelineInPreScm: "",
        pipelineOutPreSn: "",
        pipelineOutPreSr: "",
        pipelineOutPreScm: "",
        sim1Num: "",
        sim1OpenTime: "",
        sim2Num: "",
        sim2OpenTime: "",
        valueInstallTime: "",
        valueModel: "",
        valueType: "",
        valveManufacturer: "",
        imgUrl: [],
        // MQTT协议
        cylinderSnType: "0",
        batCouValue: null,
        switchTimeout: null
      },
      cloneForm: null,
      rulesUpgrade: {
        fmSize: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        fmCrc: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }]
      },
      // 表单校验
      rules: {
        actNum: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        tenantId: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        actType: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        pollIntervalHours: [{
          required: true,
          message: "请输入周期召测频率",
          trigger: "blur"
        }, {
          type: 'number',
          min: 1,
          max: 720,
          message: "周期召测频率范围为1～720小时",
          trigger: "blur"
        }],
        // areaId: [{ required: true, message: "不能为空", trigger: "change" }],
        // location: [{ required: true, message: "不能为空", trigger: "blur" }],
        // longitude: [{ required: true, message: "不能为空", trigger: "blur" }],
        // latitude: [{ required: true, message: "不能为空", trigger: "blur" }],
        roleIds: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        deptId: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        email: [{
          pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
          message: "请输入正确的邮箱地址",
          trigger: "blur"
        }],
        mobile: [{
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: "请输入正确的手机号码",
          trigger: "blur"
        }],
        cylinderSnType: [{
          required: true,
          message: "请选择气瓶传感器类型",
          trigger: "change"
        }]
      },
      tableHeader: [{
        prop: "actNum",
        label: "执行器编号"
      },
      // {
      //  prop: "valueInstallTime",
      //  label: "阀门安装日期",
      // },
      // {
      //  prop: "actFwVersion",
      //  label: "固件版本",
      // },
      // {
      //  prop: "latitude",
      //  label: "纬度",
      // },
      // {
      //  prop: "longitude",
      //  label: "经度",
      // },
      {
        prop: "actStatus",
        label: "在线状态",
        formatData: formatCode,
        type: function (row) {
          if (row.actStatus == 3) {
            return 'error';
          } else if (row.actStatus == 1) {
            return 'success';
          } else if (row.actStatus == 2) {
            return 'warning';
          } else {
            return 'error';
          }
        }
      }, {
        prop: "alarmStatus",
        label: "告警状态",
        formatData: formatAlarmCode,
        type: function (row) {
          if (row.alarmStatus == 1) {
            return 'error';
          } else {
            return 'success';
          }
        }
      }, {
        prop: "lifecycleStatusDesc",
        label: "生命周期"
      }, {
        prop: "testStatus",
        label: "测试状态",
        formatData: formatCode1,
        type: function (row) {
          // 0-待开始，1-测试中，2-已完成，3-已取消，4-异常中断
          if (row.testStatus == 0 || row.testStatus == 3) {
            return 'info';
          } else if (row.testStatus == 1) {
            return 'warning';
          } else if (row.testStatus == 2) {
            return 'success';
          } else if (row.testStatus == 4) {
            return 'error';
          }
        }
      }, {
        prop: "testResultDesc",
        label: "测试结果"
        // formatData: formatCode2,
        // type: function (row) {
        //   //  1-合格，2-不合格，3-部分合格，4-异常，NULL-未完成/已取消
        //   if (row.testResult == 1) {
        //     return 'success';
        //   } else if (row.testResult == 2) {
        //     return 'error';
        //   } else if (row.testResult == 3||row.testResult == 4) {
        //     return 'warning';
        //   }
        // }
      }, {
        prop: "batVoltage",
        label: "电池电压(mV)",
        sort: true,
        minWidth: 100
      }, {
        prop: "batLevel",
        label: "电池电量(%)",
        sort: true
      }, {
        prop: "bottlePressure",
        label: "气瓶压力(MPa)",
        minWidth: 100,
        sort: true
      }, {
        prop: "operation",
        label: "操作",
        width: "320px",
        fixed: 'right',
        operation: [{
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ["testDevice:page:addEdit"]
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ["testDevice:page:del"]
        }, {
          name: "升级",
          clickFun: row => handleUpgrade(row),
          hasPermi: ["testDevice:page:upgrade"],
          disabledHandle(row) {
            return row.actType != 1; //非mqtt禁用
          }
        }, {
          name: "校核",
          clickFun: row => handleCalibrate(row),
          hasPermi: ["device:page:zlxf"],
          disabledHandle(row) {
            return state.calibratingId !== null;
          }
        }, {
          name: "测试记录",
          clickFun: row => handleViewTestReport(row),
          hasPermi: ["testDevice:page:viewReport"]
        }, {
          name: "运行数据",
          clickFun: row => toRunData(row),
          hasPermi: ["device:page:rundata"]
        }]
      }],
      searchFormData: [{
        prop: "actNum",
        label: "执行器编号",
        placeholder: "请输入执行器编号",
        type: "text",
        span: 4
      }, {
        prop: "actStatus",
        label: "设备状态",
        placeholder: "请选择设备状态",
        filterable: true,
        type: "list",
        isSelect: false,
        options: [{
          dictValue: 1,
          dictLabel: "在线"
        }, {
          dictValue: 2,
          dictLabel: "告警"
        }, {
          dictValue: 0,
          dictLabel: "离线"
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        span: 24
      }, {
        prop: "location",
        label: "安装位置",
        placeholder: "请输入安装位置",
        type: "text",
        span: 4
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ["testDevice:page:addEdit"],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => handleAdd(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ["testDevice:page:del"],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }, {
        buttonName: "导入",
        buttonStyle: "primary",
        className: 'importBtn',
        buttonIcon: "Download",
        hasPermi: ["testDevice:page:import"],
        exp: () => handleImport()
      }, {
        buttonName: "导出",
        buttonStyle: "warning",
        hasPermi: ['testDevice:page:export'],
        className: 'exportBtn',
        buttonIcon: "Upload",
        exp: item => handleExport(item)
      }, {
        buttonName: "启动测试",
        buttonStyle: "primary",
        className: 'ceshiBtn1',
        buttonIcon: "VideoPlay",
        hasPermi: ["testDevice:page:startTest"],
        exp: () => handleStart(),
        loadingHandle(row) {
          return state.testLoading;
        }
      }, {
        buttonName: "加入测试",
        buttonStyle: "primary",
        className: 'ceshiBtn3',
        buttonIcon: "CirclePlus",
        hasPermi: ["testDevice:page:addTest"],
        exp: () => handleStart1()
      }, {
        buttonName: "出厂",
        buttonStyle: "success",
        className: 'chuchanBtn',
        buttonIcon: "CircleCheck",
        hasPermi: ["testDevice:page:batchDeploy"],
        exp: () => handleBatchDeploy(),
        disabledHandle(row) {
          return state.multiple;
        }
      }
      // {
      //   buttonName: "报废",
      //   buttonStyle: "danger",
      //   className: 'baofeiBtn',
      //   buttonIcon: "DeleteFilled",
      //   hasPermi: ["testDevice:page:batchScrap"],
      //   exp: () => handleBatchScrap(),
      //   disabledHandle(row) {
      //     return state.multiple
      //   }
      // },
      ],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "Search",
        class: "btn-liquid",
        handle: () => getList()
      }, {
        label: "重置",
        icon: "Refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }]
    });
    const statusOptions2 = ref([]);
    const store = useStore();
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    const cityProps = ref({
      label: "name",
      value: "id",
      multiple: false,
      checkStrictly: false
    });
    state.cloneForm = {
      ...state.form
    };
    onMounted(() => {
      // 查询字典数据
      dictList({
        "codeList": ["fmsccj", "fmlx", "qdmdcj", "krqtcgqbh", "krqtcgqtxfs", "krqtcgqlcfw", "gxylcgqbh", "gxylcgqtxfs", "gxylcgqlcfw", "ylcgqbh", "ylcgqlcfw", "ylcgqtxfs", "weylcgqbh", "ywylcgqtxfs", "ywylcgqlcfw", "gxjylcgqbh", "gxjylcgqtxfs", "gxjylcgqlcfw", "gxcylcgqbh", "gxcylcgqtxfs", "gxcylcgqlcfw"]
      }).then(res => {
        if (res.code == 0) {
          state.selectListAll = res.data;
        }
        console.log(state.selectListAll.fmlx, 'state.selectListAll==');
      });
      if (userType != 3) {
        state.form.tenantId = window.localStorage.getItem("tenantId");
      }
    });
    const changeTenant = () => {};
    let deviceForm = ref(null);
    const downloadTemplate = function () {
      downloadFlie('/ty-iot-manage/api/v1/actuator/exportTemplate');
    };
    // 加载测试流程列表
    const loadProcessList = () => {
      state.processListLoading = true;
      getEnabledTestProcess().then(res => {
        state.processList = res.data || [];
        state.processListLoading = false;
      }).catch(() => {
        state.processListLoading = false;
      });
    };
    // 启动测试
    const handleStart = () => {
      if (!state.ids.length) {
        ElMessage.closeAll();
        ElMessage.warning("请至少选择一个设备！");
        return;
      }
      if (state.ids.length > MAX_ACTUATOR_COUNT) {
        ElMessage.closeAll();
        ElMessage.warning(`一次最多只能选择 ${MAX_ACTUATOR_COUNT} 个执行器！`);
        return;
      }
      // 根据选中的 ids 获取对应的执行器列表数据
      state.selectedActuatorList = state.tableData.rows.filter(row => state.ids.includes(row.id));
      // 重置表单
      state.startTestForm = {
        taskName: '',
        processId: '',
        planStartTime: '',
        taskIntervalMinutes: 30,
        planEndTime: '',
        remark: ''
      };
      // 加载测试流程列表
      loadProcessList();
      state.startTestDialogVisible = true;
      setTimeout(() => {
        if (startTestFormRef.value) {
          startTestFormRef.value.clearValidate();
        }
      }, 100);
    };

    // 确认启动测试
    const handleConfirmStartTest = () => {
      if (!startTestFormRef.value) return;
      startTestFormRef.value.validate(valid => {
        if (!valid) return false;
        const testIds = state.ids;
        state.testIds = testIds;
        const params = {
          actuatorIds: testIds,
          taskName: state.startTestForm.taskName,
          processId: state.startTestForm.processId,
          planStartTime: state.startTestForm.planStartTime,
          remark: state.startTestForm.remark || ''
        };
        // 仅当containsMonitorTest为true时才传这些字段
        if (containsMonitorTest.value) {
          params.intervalMinutes = state.startTestForm.taskIntervalMinutes;
          params.planEndTime = state.startTestForm.planEndTime;
        }
        state.testLoading = true;
        startTest(params).then(res => {
          state.testLoading = false;
          state.startTestDialogVisible = false;
          ElMessage.success("启动测试成功");
          getList();
        }).catch(function () {
          state.testLoading = false;
        });
      });
    };
    const handleStop = () => {
      // if(!state.ids.length){
      //   ElMessage.closeAll()
      //   ElMessage.warning("请至少选择一个设备！");
      //   return
      // }
      // if(state.testLoading1){
      //   ElMessage.closeAll()
      //   ElMessage.warning("设备正在停止测试！");
      //   return
      // }
      const testIds = state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认停止测试?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        state.testLoading1 = true;
        return finishTest();
      }).then(res => {
        state.testLoading = false;
        ElMessage.success("停止测试");
      }).catch(function () {
        state.testLoading1 = false;
      });
    };
    // 获取测试记录列表
    const getTestList = () => {
      state.testListLoading = true;
      getTaskPageAll({
        testStatus: 0
      }).then(res => {
        state.testList = res.data || [];
        state.testListLoading = false;
      }).catch(() => {
        state.testListLoading = false;
      });
    };
    const handleStart1 = () => {
      if (!state.ids.length) {
        ElMessage.closeAll();
        ElMessage.warning("请至少选择一个设备加入测试！");
        return;
      }
      if (state.ids.length > MAX_ACTUATOR_COUNT) {
        ElMessage.closeAll();
        ElMessage.warning(`一次最多只能选择 ${MAX_ACTUATOR_COUNT} 个执行器！`);
        return;
      }
      // 根据选中的 ids 获取对应的执行器列表数据
      state.joinSelectedActuatorList = state.tableData.rows.filter(row => state.ids.includes(row.id));
      // 重置表单
      state.joinTestForm = {
        testId: ''
      };
      // 获取测试记录列表
      getTestList();
      state.joinTestDialogVisible = true;
      setTimeout(() => {
        if (joinTestFormRef.value) {
          joinTestFormRef.value.clearValidate();
        }
      }, 100);
    };

    // 确认加入测试
    const handleConfirmJoinTest = () => {
      if (!joinTestFormRef.value) return;
      joinTestFormRef.value.validate(valid => {
        if (!valid) return false;
        const addIds = state.ids;
        state.testLoading2 = true;
        joinTest({
          actuatorIds: addIds,
          testId: state.joinTestForm.testId
        }).then(res => {
          state.testLoading2 = false;
          state.joinTestDialogVisible = false;
          if (res.code == 0) {
            ElMessage.success("加入测试成功");
            getList();
          } else {
            ElMessage.error(res.message || "加入测试失败");
          }
        }).catch(() => {
          state.testLoading2 = false;
        });
      });
    };
    const handleStop1 = () => {
      const set1 = new Set(state.testIds);
      const set2 = new Set(state.ids);
      // 找出退出测试的项
      const plusIds = state.testIds.filter(item => !set2.has(item));
      if (!plusIds.length) {
        ElMessage.closeAll();
        ElMessage.warning("请至少选择一个设备退出测试！");
        return;
      }
      joinOrExitTest({
        "actIdList": plusIds,
        "testStatus": 2
      }).then(() => {
        ElMessage.success("退出测试成功");
      });
    };
    const clearValidate = prop => {
      deviceForm.value.clearValidate(prop);
    };
    const handleCityChange = function (val) {
      state.form.areaId = val[val.length - 1];
    };
    const cicyCheck = function (val, point) {
      state.form.location = val;
      state.form.longitude = point.lng;
      state.form.latitude = point.lat;
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.queryParams.pageNum = 1;
      state.queryParams.actNum = "";
      state.queryParams.actStatus = "";
      state.queryParams.location = "";
      state.queryParams.order = "";
      state.queryParams.prop = "";
      getList();
    };
    watch(() => props.id, val => {
      state.queryParams.areaId = props.id;
      getList();
    });
    // ,{immediate:true}

    // 监听路由变化，根据fromRunData参数控制页面状态
    watch(() => route.query, (newQuery, oldQuery) => {
      // 如果fromRunData不存在，重置查询参数和重新加载数据
      console.log(newQuery.fromRunData, 'newQuery.fromRunData--');
      if (!newQuery.fromRunData) {
        console.log('newQuery.fromRunData');
        resetQuery();
      }
    }, {
      immediate: true
    });

    // 监听测试流程选择变化，清除不需要的字段
    watch(() => state.startTestForm.processId, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        // 清除计划结束时间和测试频率
        state.startTestForm.planEndTime = '';
        state.startTestForm.taskIntervalMinutes = 30;
        // 清除校验
        if (startTestFormRef.value) {
          startTestFormRef.value.clearValidate(['planEndTime', 'taskIntervalMinutes']);
        }
      }
    });

    /** 新增按钮操作 */
    const handleAdd = function () {
      state.title = "添加设备";
      state.form = {
        ...state.cloneForm
      };
      state.code = "";
      state.form.tenantId = "";
      changeTenant();
      state.openDataScope = true;
    };
    // 多选框选中数据
    const MAX_ACTUATOR_COUNT = 50;
    const handleSelectionChange = function (selection) {
      if (selection.length > MAX_ACTUATOR_COUNT) {
        ElMessage.closeAll();
        ElMessage.warning(`一次最多只能选择 ${MAX_ACTUATOR_COUNT} 个执行器，超出部分已自动取消`);
        selection = selection.slice(0, MAX_ACTUATOR_COUNT);
      }
      state.ids = selection.map(item => item.id);
      state.multiple = !selection.length;
    };
    // 全选处理函数
    const handleSelectionAll = function (selection) {
      if (selection.length > MAX_ACTUATOR_COUNT) {
        ElMessage.closeAll();
        ElMessage.warning(`一次最多只能选择 ${MAX_ACTUATOR_COUNT} 个执行器，超出部分已自动取消`);
        selection = selection.slice(0, MAX_ACTUATOR_COUNT);
      }
      state.ids = selection.map(item => item.id);
      state.multiple = !selection.length;
    };
    // 控制行是否可选（只有测试中的或者将要测试的不能选择）
    const handleSelectable = (row, index) => {
      console.log(row.testStatus, !row.testStatus, index, '****');
      return row.testStatus != 0 && row.testStatus != 1;
    };
    // 排序
    const sortEvents = column => {
      state.queryParams.prop = column.prop;
      state.queryParams.order = column.order == 'ascending' ? 'asc' : 'desc';
      getList();
      console.log(column);
    };

    // 批量出厂 - 打开对话框
    const handleBatchDeploy = () => {
      if (!state.ids.length) {
        ElMessage.closeAll();
        ElMessage.warning("请至少选择一个设备进行批量出厂！");
        return;
      }
      if (state.ids.length > MAX_ACTUATOR_COUNT) {
        ElMessage.closeAll();
        ElMessage.warning(`一次最多只能选择 ${MAX_ACTUATOR_COUNT} 个执行器！`);
        return;
      }
      // 根据选中的 ids 获取对应的执行器列表数据
      state.deploySelectedActuatorList = state.tableData.rows.filter(row => state.ids.includes(row.id));
      // 重置表单
      state.batchDeployForm = {
        targetTenantId: null,
        remark: '批量执行器出厂交付给客户'
      };
      state.openBatchDeploy = true;
      setTimeout(() => {
        if (batchDeployFormRef.value) {
          batchDeployFormRef.value.clearValidate();
        }
      }, 100);
    };

    // 提交批量出厂
    const submitBatchDeploy = () => {
      if (!batchDeployFormRef.value) return;
      batchDeployFormRef.value.validate(valid => {
        if (!valid) return false;
        const actIds = state.ids;
        state.batchDeployLoading = true;
        batchDeployActuator({
          actIds: actIds,
          remark: state.batchDeployForm.remark,
          targetTenantId: state.batchDeployForm.targetTenantId
        }).then(res => {
          state.batchDeployLoading = false;
          if (res.code == 0) {
            const data = res.data;
            const {
              successCount,
              failCount,
              totalCount,
              failDetails
            } = data;

            // 全部成功
            if (successCount === totalCount) {
              ElMessage.success(`批量出厂成功，共 ${totalCount} 台执行器`);
              state.openBatchDeploy = false;
              state.ids = [];
              state.multiple = true;
              getList();
            }
            // 全部失败
            else if (failCount === totalCount) {
              let errorMsg = '批量出厂失败，详情如下：\n\n';
              failDetails.forEach(detail => {
                errorMsg += `${detail.actNum}：${detail.errorMsg}\n`;
              });
              ElMessageBox.alert(errorMsg, '批量出厂失败', {
                confirmButtonText: '确定',
                type: 'error',
                dangerouslyUseHTMLString: false,
                customClass: 'deploy-fail-dialog'
              });
            }
            // 部分成功部分失败
            else {
              let message = `批量出厂完成：成功 ${successCount} 台，失败 ${failCount} 台\n\n`;
              if (failDetails && failDetails.length > 0) {
                message += '失败详情：\n';
                failDetails.forEach(detail => {
                  message += `${detail.actNum}：${detail.errorMsg}\n`;
                });
              }
              ElMessageBox.alert(message, '批量出厂结果', {
                confirmButtonText: '确定',
                type: 'warning',
                dangerouslyUseHTMLString: false,
                customClass: 'deploy-fail-dialog'
              });
              state.openBatchDeploy = false;
              state.ids = [];
              state.multiple = true;
              getList();
            }
          } else {
            ElMessage.error(res.msg || "批量出厂失败");
          }
        }).catch(() => {
          state.batchDeployLoading = false;
        });
      });
    };

    // 执行器校核
    const handleCalibrate = async row => {
      if (manualOperation.busy.value) return;
      try {
        await ElMessageBox.confirm(`确定要对执行器 ${row.actNum} 进行校核吗？`, '执行器校核', {
          type: 'warning'
        });
      } catch (_) {
        return;
      }
      state.calibratingId = row.id;
      state.calibrateLoading = true;
      try {
        const result = await manualOperation.run(() => calibrateActuator(row.id), {
          operation: '校核'
        });
        // ElMessage.closeAll();
        if (result?.status === 'SUCCESS') {
          ElMessage.success(`执行器 ${row.actNum} 校核成功`);
        } else {
          ElMessage.error(`执行器 ${row.actNum} 校核失败`);
        }
        getList();
      } catch (_) {
        ElMessage.error(`执行器 ${row.actNum} 校核失败`);
      } finally {
        state.calibratingId = null;
        state.calibrateLoading = false;
      }
    };

    // 取消批量出厂
    const cancelBatchDeploy = () => {
      state.openBatchDeploy = false;
      state.batchDeployForm = {
        targetTenantId: null,
        remark: '批量执行器出厂交付给客户'
      };
    };

    // 批量报废 - 打开对话框
    const handleBatchScrap = () => {
      if (!state.ids.length) {
        ElMessage.closeAll();
        ElMessage.warning("请至少选择一个设备进行批量报废！");
        return;
      }
      if (state.ids.length > MAX_ACTUATOR_COUNT) {
        ElMessage.closeAll();
        ElMessage.warning(`一次最多只能选择 ${MAX_ACTUATOR_COUNT} 个执行器！`);
        return;
      }
      // 根据选中的 ids 获取对应的执行器列表数据
      state.deploySelectedActuatorList = state.tableData.rows.filter(row => state.ids.includes(row.id));
      // 重置表单
      state.batchScrapForm = {
        scrapReason: '',
        remark: ''
      };
      state.openBatchScrap = true;
      setTimeout(() => {
        if (batchScrapFormRef.value) {
          batchScrapFormRef.value.clearValidate();
        }
      }, 100);
    };

    // 提交批量报废
    const submitBatchScrap = () => {
      if (!batchScrapFormRef.value) return;
      batchScrapFormRef.value.validate(valid => {
        if (!valid) return false;
        const actIds = state.ids;
        state.batchScrapLoading = true;
        batchScrapActuator({
          actIds: actIds,
          scrapReason: state.batchScrapForm.scrapReason,
          remark: state.batchScrapForm.remark
        }).then(res => {
          state.batchScrapLoading = false;
          state.openBatchScrap = false;
          if (res.code == 0) {
            ElMessage.success("批量报废成功");
            state.ids = [];
            state.multiple = true;
            getList();
          } else {
            ElMessage.error(res.msg || "批量报废失败");
          }
        }).catch(() => {
          state.batchScrapLoading = false;
        });
      });
    };

    // 取消批量报废
    const cancelBatchScrap = () => {
      state.openBatchScrap = false;
      state.batchScrapForm = {
        scrapReason: '',
        remark: ''
      };
    };
    const toRunData = row => {
      router.push(`/deviceRunData?actId=${row.id}&actNum=${row.actNum}&areaId=${state.queryParams.areaId}&fromRunData=true`);
    };
    // 查看检测报告 - 打开测试记录列表
    const handleViewTestReport = async row => {
      state.openTestReport = true;
      state.testReportList = [];
      try {
        const res = await getActTaskPageAll(row.id);
        if (res.code == 0) {
          state.testReportList = res.data || [];
        }
      } catch (error) {
        state.testReportList = [];
      }
    };

    // 预览检测报告
    const handlePreviewReport = row => {
      if (!row.pdfPath) {
        ElMessage.warning('暂无检测报告');
        return;
      }
      state.currentPdfUrl = window.g.pdfUrlPrex + row.pdfPath;
      state.reportDialogVisible = true;
    };

    // 格式化日期时间
    const formatDateTime = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // 获取测试状态标签类型
    const getTestStatusTagType = status => {
      switch (status) {
        case 0:
          return 'info';
        case 1:
          return 'warning';
        case 2:
          return 'success';
        case 3:
          return 'default';
        case 4:
          return 'danger';
        default:
          return 'default';
      }
    };

    // 获取测试结果标签类型
    const getTestResultTagType = result => {
      switch (result) {
        case 1:
          return 'success';
        case 2:
          return 'danger';
        case 3:
          return 'warning';
        case 4:
          return 'danger';
        default:
          return 'default';
      }
    };

    // 设备控制
    const handleOperate = function (row) {
      if (manualOperation.busy.value) return;
      manualOperation.clearProgress();
      state.openOperate = true;
      state.actNum = row.actNum;
      operatedDevice = row;
    };
    const closeOperate = function () {
      state.openOperate = false;
    };
    const clickOperate = async function (type) {
      if (!operatedDevice || manualOperation.busy.value) return;
      const params = {
        id: operatedDevice.id,
        valuePos: operatedDevice.actType == 2 && type == 0 ? 2 : type,
        valueOpenPos: type == 1 ? 90 : 0
      };
      const result = await manualOperation.run(() => actuatorInvoke(params), {
        operation: type == 1 ? '开阀' : '关阀'
      });
      if (result?.finished) {
        state.openOperate = false;
        getList();
      }
    };
    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = "修改设备";
      state.loadgingDataScope = true;
      state.openDataScope = true;
      state.form.imgUrl = [];
      weChatrequest({
        url: `/api/v1/actuator/${row.id}`,
        method: "get"
      }).then(res => {
        if (res.code == 0) {
          state.form = {
            ...res.data
          };
          // state.code=res.data.areaId
          // state.point={lng:res.data.longitude,lat:res.data.latitude}
          let imgList = state.form.imgUrl ? res.data.imgUrl.split(",") : [];
          state.form.imgUrl = imgList;
        }
        state.loadgingDataScope = false;
      }).catch(() => {
        state.loadgingDataScope = false;
      });
    };
    const cancelDataScope = function () {
      state.openDataScope = false;
    };
    // 升级
    const submitUpgrade = () => {
      const formRef = unref(upgradeForm);
      formRef.validate(valid => {
        if (valid) {
          state.upgradeLoading = true;
          let params = {
            ...state.formUpgrade
          };
          params.actNum = state.actNum;
          upgradeActuator(params).then(response => {
            if (response.code == 0) {
              ElMessage.success("升级成功");
              state.openUpgrade = false;
              getList();
            } else {
              ElMessage.error(response.msg);
            }
            state.upgradeLoading = false;
          }).catch(() => {
            state.upgradeLoading = false;
          });
        }
      });
    };
    const cancelUpgrade = function () {
      state.openUpgrade = false;
    };
    // 导入
    const handleImport = function () {
      state.uploadForm.fileList = [];
      state.dialogVisible = true;
    };
    /** 导出文件 */
    const handleExport = function (row) {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认导出数据项?', "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        let params = {
          ...state.queryParams
        };
        if (state.queryParams.actStatus == 2) {
          delete params.actStatus;
          params.hasAlarm = 1;
        }
        actuatorEport(params).then(res => {
          if (res.status === 200) {
            let fileName = decodeURI(res.headers["content-disposition"].split("utf-8''")[1]);
            download(res.data, fileName);
          }
        }).catch(() => {});
      });
    };
    const closeUpload = function () {
      state.dialogVisible = false;
    };
    const handleRemove = function () {
      const formRef = unref(deviceForm);
      state.uploadForm.fileList = [];
      formRef.validate();
    };
    const uploadRef = ref(null);
    const submitUpload = function (formEl) {
      const upload = unref(uploadRef);
      formEl.validate(valid => {
        if (valid) {
          upload.submit();
        }
      });
    };
    const ruleFormRef = ref(null);
    const uploadChange = function (file, list) {
      const formRef = unref(ruleFormRef);
      const fileName = file.name.split('.').pop().toLowerCase();
      if (!['xlsx'].includes(fileName)) {
        state.uploadForm.fileList = [];
        ElMessage.warning("文件类型只支持xlsx格式！");
        formRef.validate();
        return;
      }
      state.uploadForm.fileList = [file];
      formRef.validate();
    };
    const uploadFile = function (params) {
      state.exportLoading = true;
      let formData = new FormData();
      formData.append('file', params.file);
      importExcel(formData).then(res => {
        state.saveLoading = false;
        state.exportLoading = false;
        state.dialogVisible = false;
        ElMessage.closeAll();
        if (res.code == 0) {
          if (res?.data?.code == 1001) {
            ElMessage.error(res?.data?.message);
          } else {
            ElMessage.success('导入成功！');
          }
          getList();
        } else {
          ElMessage.error(res.message);
        }
      }).catch(error => {
        ElMessage.closeAll();
        ElMessage.warning(error);
        state.saveLoading = false;
        state.exportLoading = false;
      });
    };

    /** 修改/新增设备提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(deviceForm);
      formRef.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          if (state.form.id) {
            let params = {
              ...state.form
            };
            if (state.form.imgUrl.length > 0) {
              params.imgUrl = state.form.imgUrl.join(",");
            } else {
              params.imgUrl = "";
            }
            editActuator(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            let params = {
              ...state.form
            };
            if (state.form.imgUrl.length > 0) {
              params.imgUrl = state.form.imgUrl.join(",");
            } else {
              params.imgUrl = "";
            }
            addActuator(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const roleIds = row.id || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return deleteActuator(roleIds);
      }).then(res => {
        getList();
        ElMessage.success("删除成功");
      }).catch(function () {});
    };
    function getList() {
      state.loading = true;
      console.log(state.queryParams, 'state.queryParams--');
      let params = {
        ...state.queryParams
      };
      if (state.queryParams.actStatus == 2) {
        delete params.actStatus;
        params.hasAlarm = 1;
      }
      listTestPage(params).then(res => {
        state.tableData.rows = res.data.records;
        state.tableData.total = res.data.total;
        state.loading = false;
      });
    }
    function handleUpgrade(row) {
      state.actNum = row.actNum;
      state.formUpgrade = {
        fmSize: "",
        fmCrc: ""
      };
      state.openUpgrade = true;
    }
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_Open = _resolveComponent("Open");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_TurnOff = _resolveComponent("TurnOff");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_upload = _resolveComponent("el-upload");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_Iconfont, {
        name: "fajingguanli",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          icon: item.buttonIcon,
          loading: item.loadingHandle?.(item.prop, form.value),
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "icon", "loading", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.tableData,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        hasSelect: true,
        onGetList: getList,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onSelectionChange: handleSelectionChange,
        onSelectAll: handleSelectionAll,
        columnSetting: false,
        onSortEvents: sortEvents,
        selectable: handleSelectable
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])])), [[_directive_loading, state.calibrateLoading ? {
        text: _unref(manualOperation).progressText.value
      } : false]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.openUpgrade,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.openUpgrade = $event),
        size: "700px",
        title: "固件升级",
        "close-on-click-modal": false,
        onClose: cancelUpgrade
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitUpgrade,
          loading: _ctx.upgradeLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelUpgrade
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.formUpgrade,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "upgradeForm",
          ref: upgradeForm,
          rules: state.rulesUpgrade,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, null, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "SIZE",
                prop: "fmSize"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.formUpgrade.fmSize,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.formUpgrade.fmSize = $event),
                  type: "number",
                  placeholder: "SIZE",
                  maxlength: "32"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, null, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "CRC",
                prop: "fmCrc"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.formUpgrade.fmCrc,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.formUpgrade.fmCrc = $event),
                  type: "number",
                  placeholder: "CRC",
                  maxlength: "16"
                }, {
                  prepend: _withCtx(() => [_createTextVNode("0x")]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => state.openDataScope = $event),
        size: "800px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
          model: state.form,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "deviceForm",
          ref: deviceForm,
          rules: state.rules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "所属租户",
                prop: "tenantId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.tenantId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.form.tenantId = $event),
                  placeholder: "请选择所属租户",
                  onChange: changeTenant
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.tenantName,
                      value: item.tenantId,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "执行器编号",
                prop: "actNum"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.actNum,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => state.form.actNum = $event),
                  placeholder: "请输入执行器编号最多40个字符",
                  maxlength: "40",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "协议类型",
                prop: "actType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.actType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => state.form.actType = $event),
                  placeholder: "请选择协议类型"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "MQTT",
                    value: 1
                  }), _createVNode(_component_el_option, {
                    label: "AEP",
                    value: 2
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "上报频率 (1–720h (默认24h))",
                prop: "pollIntervalHours"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  modelValue: state.form.pollIntervalHours,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.form.pollIntervalHours = $event),
                  min: 1,
                  max: 720,
                  step: 1,
                  "controls-position": "right",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), state.form.actType == 2 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "IMEI",
                prop: "imei"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.imei,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => state.form.imei = $event),
                  placeholder: "请输入IMEI最多40个字符",
                  maxlength: "40",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "执行器图片",
                prop: "imgUrl"
              }, {
                default: _withCtx(() => [_createVNode(_unref(EIUploadMutiplePic), {
                  "file-list": state.form.imgUrl,
                  "onUpdate:fileList": _cache[9] || (_cache[9] = $event => state.form.imgUrl = $event),
                  onClearValidate: _cache[10] || (_cache[10] = $event => clearValidate(state.form.imgUrl)),
                  uploadTip: "最多上传6张图片"
                }, null, 8, ["file-list"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "阀门生产厂家",
                prop: "valveManufacturer"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.valveManufacturer,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => state.form.valveManufacturer = $event),
                  placeholder: "请选择阀门生产厂家"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.fmsccj, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "阀门类型",
                prop: "valueType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.valueType,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => state.form.valueType = $event),
                  placeholder: "请选择阀门类型"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.fmlx, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "阀门型号",
                prop: "valueModel"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.valueModel,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => state.form.valueModel = $event),
                  placeholder: "请输入阀门型号最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "阀门安装时间",
                prop: "valueInstallTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: state.form.valueInstallTime,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => state.form.valueInstallTime = $event),
                  "value-format": "YYYY-MM-DD",
                  type: "date",
                  placeholder: "请选择阀门安装时间",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "气动马达型号",
                prop: "airMotor"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.airMotor,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => state.form.airMotor = $event),
                  placeholder: "请输入气动马达型号最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "气动马达厂家",
                prop: "airManufacturer"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.airManufacturer,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => state.form.airManufacturer = $event),
                  placeholder: "请选择气动马达厂家"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.qdmdcj, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "主板型号",
                prop: "motherBorderModel"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.motherBorderModel,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => state.form.motherBorderModel = $event),
                  placeholder: "请输入主板型号最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "主板版本号",
                prop: "motherBorderVersion"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.motherBorderVersion,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => state.form.motherBorderVersion = $event),
                  placeholder: "请输入主板版本号最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "SIM卡1卡号",
                prop: "sim1Num"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.sim1Num,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => state.form.sim1Num = $event),
                  placeholder: "请输入SIM卡1卡号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "SIM卡1开卡时间",
                prop: "sim1OpenTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: state.form.sim1OpenTime,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => state.form.sim1OpenTime = $event),
                  "value-format": "YYYY-MM-DD",
                  type: "date",
                  placeholder: "请选择SIM卡1开卡时间",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "SIM卡2卡号",
                prop: "sim2Num"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.sim2Num,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => state.form.sim2Num = $event),
                  placeholder: "请输入SIM卡2卡号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "SIM卡2开卡时间",
                prop: "sim2OpenTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: state.form.sim2OpenTime,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => state.form.sim2OpenTime = $event),
                  "value-format": "YYYY-MM-DD",
                  type: "date",
                  placeholder: "请选择SIM卡2开卡时间",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "气瓶编号",
                prop: "cylinderNum"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.cylinderNum,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => state.form.cylinderNum = $event),
                  placeholder: "请输入气瓶编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "气瓶的年检期限",
                prop: "cylinderEndTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.cylinderEndTime,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => state.form.cylinderEndTime = $event),
                  placeholder: "请输入气瓶的年检期限最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), state.form.actType == 1 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "气瓶传感器类型",
                prop: "cylinderSnType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.cylinderSnType,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => state.form.cylinderSnType = $event),
                  placeholder: "请选择气瓶传感器类型"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "压力传感器",
                    value: "0"
                  }), _createVNode(_component_el_option, {
                    label: "宝鸡麦克",
                    value: "1"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), state.form.actType == 1 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "电池容量(mAh)",
                prop: "batCouValue"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  modelValue: state.form.batCouValue,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => state.form.batCouValue = $event),
                  min: 0,
                  step: 1,
                  controls: false,
                  placeholder: "请输入电池容量",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), state.form.actType == 1 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 2,
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开关阀超时时间(秒)",
                prop: "switchTimeout"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  modelValue: state.form.switchTimeout,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => state.form.switchTimeout = $event),
                  min: 10,
                  max: 60,
                  step: 1,
                  controls: false,
                  placeholder: "请输入开关阀超时时间(10-60秒)",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]), _hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_row, {
            gutter: 15,
            style: {
              "flex": "1"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "可燃气体传感器编号",
                prop: "combPressureSn"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.combPressureSn,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => state.form.combPressureSn = $event),
                  placeholder: "请输入编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "可燃气体传感器通信方式",
                prop: "combPressureScm"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.combPressureScm,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => state.form.combPressureScm = $event),
                  placeholder: "请选择通信方式"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.krqtcgqtxfs, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "可燃气体传感器量程范围",
                prop: "combPressureSr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.combPressureSr,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => state.form.combPressureSr = $event),
                  placeholder: "量程范围"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.krqtcgqlcfw, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力传感器编号",
                prop: "pipelinePressureSn"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.pipelinePressureSn,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => state.form.pipelinePressureSn = $event),
                  placeholder: "请输入编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力传感器通信方式",
                prop: "pipelinePressureScm"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pipelinePressureScm,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => state.form.pipelinePressureScm = $event),
                  placeholder: "请选择通信方式"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.gxylcgqtxfs, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力传感器量程范围",
                prop: "pipelinePressureSr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pipelinePressureSr,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => state.form.pipelinePressureSr = $event),
                  placeholder: "量程范围"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.gxylcgqlcfw, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "压力传感器编号",
                prop: "pressureSn"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.pressureSn,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => state.form.pressureSn = $event),
                  placeholder: "请输入编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "压力传感器通信方式",
                prop: "pressureScm"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pressureScm,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => state.form.pressureScm = $event),
                  placeholder: "请选择通信方式"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.ylcgqtxfs, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "压力传感器量程范围",
                prop: "pressureSr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pressureSr,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => state.form.pressureSr = $event),
                  placeholder: "量程范围"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.ylcgqlcfw, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "液位压力传感器编号",
                prop: "liquidLevelPreSn"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.liquidLevelPreSn,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => state.form.liquidLevelPreSn = $event),
                  placeholder: "请输入编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "液位压力传感器通信方式",
                prop: "liquidLevelPreScm"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.liquidLevelPreScm,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => state.form.liquidLevelPreScm = $event),
                  placeholder: "请选择通信方式"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.ywylcgqtxfs, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "液位压力传感器量程范围",
                prop: "liquidLevelPreSr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.liquidLevelPreSr,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => state.form.liquidLevelPreSr = $event),
                  placeholder: "量程范围"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.ywylcgqlcfw, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力进传感器编号",
                prop: "pipelineInPreSn"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.pipelineInPreSn,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => state.form.pipelineInPreSn = $event),
                  placeholder: "请输入编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力进传感器通信方式",
                prop: "pipelineInPreScm"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pipelineInPreScm,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => state.form.pipelineInPreScm = $event),
                  placeholder: "请选择通信方式"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.gxjylcgqtxfs, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力进传感器量程范围",
                prop: "pipelineInPreSr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pipelineInPreSr,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => state.form.pipelineInPreSr = $event),
                  placeholder: "量程范围"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.gxjylcgqlcfw, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力出传感器编号",
                prop: "pipelineOutPreSn"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.pipelineOutPreSn,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => state.form.pipelineOutPreSn = $event),
                  placeholder: "请输入编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力出传感器通信方式",
                prop: "pipelineOutPreScm"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pipelineOutPreScm,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => state.form.pipelineOutPreScm = $event),
                  placeholder: "请选择通信方式"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.gxcylcgqtxfs, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "管线压力出传感器量程范围",
                prop: "pipelineOutPreSr"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.pipelineOutPreSr,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => state.form.pipelineOutPreSr = $event),
                  placeholder: "量程范围"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectListAll.gxcylcgqlcfw, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }, 8, ["model", "rules"])])), [[_directive_loading, state.loadgingDataScope]])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_commonDrawer, {
        title: "控制设备",
        modelValue: state.openOperate,
        "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => state.openOperate = $event),
        width: "500px",
        "close-on-click-modal": false,
        "before-close": closeOperate
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "auto-upload": false,
          model: state.operateForm,
          rules: state.operateFormRules,
          "status-icon": "",
          "label-width": "120px",
          class: "commonForm"
        }, {
          default: _withCtx(() => [_hoisted_17, _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[47] || (_cache[47] = $event => clickOperate(1)),
            disabled: _unref(manualOperation).busy.value
          }, {
            default: _withCtx(() => [_createTextVNode(" 开 阀"), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_Open)]),
              _: 1
            })]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[48] || (_cache[48] = $event => clickOperate(0)),
            disabled: _unref(manualOperation).busy.value
          }, {
            default: _withCtx(() => [_createTextVNode(" 关 阀"), _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_component_TurnOff)]),
              _: 1
            })]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, _unref(manualOperation).busy.value ? {
          text: _unref(manualOperation).progressText.value
        } : false]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        title: "执行器批量出厂",
        modelValue: state.openBatchDeploy,
        "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => state.openBatchDeploy = $event),
        size: "600px",
        "close-on-click-modal": false,
        onClose: cancelBatchDeploy
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitBatchDeploy,
          loading: state.batchDeployLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelBatchDeploy
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.batchDeployForm,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "batchDeployFormRef",
          ref: batchDeployFormRef,
          rules: state.batchDeployRules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "已选执行器",
                prop: "selectedActuators"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.deploySelectedActuatorList, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_tag, {
                    key: index
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.actNum), 1)]),
                    _: 2
                  }, 1024);
                }), 128))])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "目标租户",
                prop: "targetTenantId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.batchDeployForm.targetTenantId,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => state.batchDeployForm.targetTenantId = $event),
                  placeholder: "请选择目标租户",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.tenantName,
                      value: item.tenantId,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.batchDeployForm.remark,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => state.batchDeployForm.remark = $event),
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入备注",
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        title: "执行器批量报废",
        modelValue: state.openBatchScrap,
        "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => state.openBatchScrap = $event),
        size: "600px",
        "close-on-click-modal": false,
        onClose: cancelBatchScrap
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitBatchScrap,
          loading: state.batchScrapLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelBatchScrap
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.batchScrapForm,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "batchScrapFormRef",
          ref: batchScrapFormRef,
          rules: state.batchScrapRules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "已选执行器",
                prop: "selectedActuators"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.deploySelectedActuatorList, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_tag, {
                    key: index
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.actNum), 1)]),
                    _: 2
                  }, 1024);
                }), 128))])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "报废原因",
                prop: "scrapReason"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.batchScrapForm.scrapReason,
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => state.batchScrapForm.scrapReason = $event),
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入报废原因",
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.batchScrapForm.remark,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => state.batchScrapForm.remark = $event),
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入备注",
                  maxlength: "200",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        title: "测试记录",
        modelValue: state.openTestReport,
        "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => state.openTestReport = $event),
        size: "900px",
        "close-on-click-modal": false
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: state.testReportList,
          border: "",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "taskName",
            label: "测试任务名称"
          }), _createVNode(_component_el_table_column, {
            prop: "processName",
            label: "测试流程名称"
          }), _createVNode(_component_el_table_column, {
            prop: "startTime",
            label: "测试开始时间"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.startTime ? formatDateTime(scope.row.startTime) : '-'), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "endTime",
            label: "测试结束时间"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.endTime ? formatDateTime(scope.row.endTime) : '-'), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "testStatus",
            label: "测试状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_tag, {
              type: getTestStatusTagType(scope.row.testStatus)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.testStatusDesc || '-'), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "testResult",
            label: "测试结果"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.testResultDesc) + " ", 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "operation",
            fixed: "right",
            label: "操作",
            width: "120",
            align: "center"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              type: "primary",
              link: "",
              size: "small",
              onClick: $event => handlePreviewReport(scope.row),
              disabled: !scope.row.pdfPath
            }, {
              default: _withCtx(() => [_createTextVNode("查看报告")]),
              _: 2
            }, 1032, ["onClick", "disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, state.testReportLoading]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: state.reportDialogVisible,
        "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => state.reportDialogVisible = $event),
        title: "检测报告预览",
        class: "pdf-diaog",
        size: "900px",
        "close-on-click-modal": true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("iframe", {
          src: state.currentPdfUrl,
          frameborder: "0",
          class: "pdf-iframe"
        }, null, 8, _hoisted_23)])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        title: "导入设备",
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => state.dialogVisible = $event),
        width: "500px",
        "close-on-click-modal": false,
        "before-close": closeUpload
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[58] || (_cache[58] = $event => submitUpload(ruleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: closeUpload
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "auto-upload": false,
          model: state.uploadForm,
          rules: state.uploadFormRules,
          "status-icon": "",
          "label-width": "120px",
          class: "commonForm"
        }, {
          default: _withCtx(() => [_hoisted_24, _createVNode(_component_el_form_item, {
            label: "模板"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadTemplate
            }, {
              default: _withCtx(() => [_createTextVNode("下载模板")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文件",
            prop: "fileList"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              "auto-upload": false,
              class: "upload-demo",
              action: "",
              "on-remove": handleRemove,
              "file-list": state.uploadForm.fileList,
              "on-change": uploadChange,
              "http-request": uploadFile
            }, {
              tip: _withCtx(() => [_hoisted_25]),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("上传文件")]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: state.startTestDialogVisible,
        "onUpdate:modelValue": _cache[67] || (_cache[67] = $event => state.startTestDialogVisible = $event),
        title: "启动测试",
        width: "600px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createVNode(_component_el_button, {
          onClick: _cache[66] || (_cache[66] = $event => state.startTestDialogVisible = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: state.testLoading,
          onClick: handleConfirmStartTest
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.startTestForm,
          rules: state.startTestRules,
          ref_key: "startTestFormRef",
          ref: startTestFormRef,
          "label-width": "120px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "已选执行器",
            style: {
              "margin-top": "20px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectedActuatorList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: index
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.actNum), 1)]),
                _: 2
              }, 1024);
            }), 128))])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试名称",
            prop: "taskName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: state.startTestForm.taskName,
              "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => state.startTestForm.taskName = $event),
              placeholder: "请输入测试名称",
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试流程",
            prop: "processId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: state.startTestForm.processId,
              "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => state.startTestForm.processId = $event),
              placeholder: "请选择测试流程",
              filterable: "",
              style: {
                "width": "100%"
              },
              loading: state.processListLoading
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.processList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.processName,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "loading"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "计划开始时间",
            prop: "planStartTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: state.startTestForm.planStartTime,
              "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => state.startTestForm.planStartTime = $event),
              type: "datetime",
              placeholder: "请选择计划开始时间",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              "disabled-date": date => date.getTime() < Date.now() - 86400000,
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue", "disabled-date"])]),
            _: 1
          }), _unref(containsMonitorTest) ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "计划结束时间",
            prop: "planEndTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: state.startTestForm.planEndTime,
              "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => state.startTestForm.planEndTime = $event),
              type: "datetime",
              placeholder: "计划结束时间默认为3天后",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(containsMonitorTest) ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "测试频率（分钟，5~1440）",
            prop: "taskIntervalMinutes"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: state.startTestForm.taskIntervalMinutes,
              "onUpdate:modelValue": _cache[64] || (_cache[64] = $event => state.startTestForm.taskIntervalMinutes = $event),
              min: 5,
              max: 1440,
              placeholder: "请输入测试频率",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: state.startTestForm.remark,
              "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => state.startTestForm.remark = $event),
              type: "textarea",
              rows: 4,
              placeholder: "请输入备注",
              maxlength: "500",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: state.joinTestDialogVisible,
        "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => state.joinTestDialogVisible = $event),
        title: "加入测试",
        width: "600px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_button, {
          onClick: _cache[69] || (_cache[69] = $event => state.joinTestDialogVisible = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: state.testLoading2,
          onClick: handleConfirmJoinTest
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.joinTestForm,
          rules: state.joinTestRules,
          ref_key: "joinTestFormRef",
          ref: joinTestFormRef,
          "label-width": "120px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "已选执行器"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.joinSelectedActuatorList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: index
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.actNum), 1)]),
                _: 2
              }, 1024);
            }), 128))])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试任务",
            prop: "testId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: state.joinTestForm.testId,
              "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => state.joinTestForm.testId = $event),
              placeholder: "请选择测试任务",
              filterable: "",
              style: {
                "width": "100%"
              },
              loading: state.testListLoading
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.testList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.tenantId,
                  label: item.taskName,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "loading"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, state.exportLoading]]);
    };
  }
};